/*
import { toast } from "react-toastify";

const showSuccess = (message) => {
  toast.success(message, { position: "top-right", autoClose: 3000 });
};

const showError = (message) => {
  toast.error(message, { position: "top-right", autoClose: 3000 });
};

export default { showSuccess, showError };
*/

import { toast } from "react-toastify";

const showSuccess = (message) => {
  toast.success(message, { position: "top-right", autoClose: 3000 });
};

const showError = (message) => {
  toast.error(message, { position: "top-right", autoClose: 3000 });
};

const toastService = {
  showSuccess,
  showError,
};

export default toastService;
